/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const SpanBoldStyled = styled.span`
  font-weight: 400;
}`;

